import { type IPrivateLeadBoard } from '@inpart-io/padme-iap';
import { type MutationTree } from 'vuex';

import { type IPrivateLeadBoardState } from './types';

export const RECEIVE_DEFAULT_BOARD = 'receiveDefaultBoard';

export const mutations: MutationTree<IPrivateLeadBoardState> = {
    [RECEIVE_DEFAULT_BOARD](_state: IPrivateLeadBoardState, { board }: { board: IPrivateLeadBoard }) {
        _state.defaultBoards.set(
            board.targetType,
            Object.assign({}, _state.defaultBoards.get(board.targetType), { [board.defaultViewCategory]: board.dobjId })
        );
    }
};
